import axiosInstance from './base.api';
import { getEnvironmentVariable } from '../utils';

type SiteConfigsDTO = {
    name: string;
    logo: string;
    domains?: {
        [key: string]: SiteConfigs;
    }
}

export type SiteConfigs = {
    footer: string;
    name: string;
    logo: string;
}

const baseUrl = getEnvironmentVariable('REACT_APP_IMAGE_BASE_URL');
const IMAGE_BASE_URL = `${baseUrl}/assets/img/`;

export const siteDefaultConfigs: SiteConfigs = {
    name: 'SPARKDIT',
    footer: 'SPARKDIT INC',
    logo: IMAGE_BASE_URL + 'logo_old.svg',
};

export const getSiteConfigs = async (): Promise<SiteConfigs> => {
    const response = await axiosInstance.post<SiteConfigsDTO>('/sitepart/metadata', { name: 'react' });
    if (!response.data.domains) {
        return siteDefaultConfigs;
    }

    const configs = response.data.domains[window.location.host];
    if (!configs) {
        return siteDefaultConfigs;
    }

    return {
        ...configs,
        logo: IMAGE_BASE_URL + configs.logo,
    };
};
